import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { RouterModule } from '@angular/router';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import localeFr from '@angular/common/locales/fr';
import { SharedLibsModule } from '@shared/shared-libs.module';
import { CommunitiesRecipesSearchComponent } from './communities-recipes-search/communities-recipes-search.component';
import { CommunitiesRecipesPreviewComponent } from './communities-recipes-preview/communities-recipes-preview.component';
import { communitiesRecipesRoutes } from './communities-recipes.route';
import { CommunitiesRecipesSearchQueryComponent } from './communities-recipes-search/communities-recipes-search-query/communities-recipes-search-query.component';
import { CommunitiesRecipesSearchResultComponent } from './communities-recipes-search-result/communities-recipes-search-result.component';
import { RecipeSearchBarComponent } from '@recipes/recipes-search/recipes-search-query/recipe-search-bar/recipe-search-bar.component';
import { DataTableManagerComponent } from '@shared/components/data-table-manager/data-table-manager.component';
registerLocaleData(localeFr);

@NgModule({
  declarations: [
    CommunitiesRecipesSearchComponent,
    CommunitiesRecipesPreviewComponent,
    CommunitiesRecipesSearchQueryComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedLibsModule,
    RouterModule.forChild(communitiesRecipesRoutes),
    EditorModule,
    RecipeSearchBarComponent,
    DataTableManagerComponent,
    CommunitiesRecipesSearchResultComponent,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }],
})
export class CommunitiesRecipesModule {}
